import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InterogariPlatiComponent } from './interogari-plati.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [InterogariPlatiComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ]
})
export class InterogariPlatiModule { }
